import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconRocket2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="rocket-2, startup, launch"><path d="M14.062 21.25H9.94247C5.73067 14.4439 5.30801 8.40278 12.0022 2.75C18.6965 8.40278 18.2738 14.4439 14.062 21.25Z" stroke="currentColor" strokeWidth="1.5"/><path d="M6.85915 10.9385L3.77344 15.0528V20.1956H8.91629" stroke="currentColor" strokeWidth="1.5"/><path d="M17.1431 10.9385L20.2288 15.0528V20.1956H15.0859" stroke="currentColor" strokeWidth="1.5"/><circle cx="12" cy="12" r="1.5" stroke="currentColor" strokeWidth="1.54286"/></CentralIconBase>;
};

export default IconRocket2;
